import { forwardRef } from "react";
import { Icon, IconClientSVGProps } from "@repo/ui/icon";

export const ArrowR = forwardRef<SVGSVGElement, IconClientSVGProps>(
  ({ label, stroke = "#0f0f14", strokeOpacity, ...props }, ref) => {
    return (
      <Icon label={label}>
        <svg
          ref={ref}
          {...props}
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5 14L11 8.16216L7.38153 4.44589M5 2L6.46053 3.5"
            stroke={stroke}
            strokeOpacity={strokeOpacity}
            strokeLinecap="square"
          />
        </svg>
      </Icon>
    );
  },
);

ArrowR.displayName = "ArrowR";
